/* 夏侯淵傳・第 1 章：傳饋相繼（200 年）
 * 官渡之後的曹軍大營在北邊；西是兗州的糧倉、南是豫州、東是徐州，三條糧道各自通到大營，外圍一條小路把三座糧倉連起來。 */
export const CAMP = [3300, 800], DEPOTS = { yan: [900, 2300], yu: [3300, 3700], xu: [5700, 2300] };
export const ROUTES = { yan: [DEPOTS.yan, [1600, 1650], [2500, 1150], CAMP], yu: [DEPOTS.yu, [3150, 2900], [3450, 1900], CAMP], xu: [DEPOTS.xu, [5000, 1650], [4100, 1150], CAMP] };
export default {
  id: 'xiahouyuan_yanyu', name: '兗豫徐', W: 6600, H: 4200, seed: 200,
  bases: [CAMP, [3300, 2300]],
  roads: [
    ...Object.values(ROUTES).map((p) => ({ pts: p, w: 130 })),
    { pts: [DEPOTS.yan, [1600, 3200], DEPOTS.yu, [5000, 3200], DEPOTS.xu], w: 100 },
  ],
  rocks: [[2000, 2500, 320, 160], [4600, 2500, 320, 160], [3300, 1500, 240, 120], [900, 950, 300, 150], [5700, 950, 300, 150]],
  woods: 0.45,
  sight: 0.85,
  clearings: [[CAMP[0], CAMP[1], 500], ...Object.values(DEPOTS).map(([x, y]) => [x, y, 340])],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 7, r: 380, chief: true, col: '#3b5a99', flag: '曹' }],
  villages: [{ x: 1900, y: 3100, n: 3, r: 220 }, { x: 4700, y: 3100, n: 3, r: 220 }],
  fields: [[1300, 2800, 420, 200], [5300, 2800, 420, 200], [3300, 3200, 360, 160]],
  grass: [[2200, 1350, 200, 90], [4400, 1350, 200, 90], [3600, 2600, 180, 80]],
};
